"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = testForPassiveScroll;

function testForPassiveScroll() {
  var supportsPassiveOption = false;

  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get() {
        supportsPassiveOption = true;
      }
    });
    window.addEventListener('test', null, opts);
    window.removeEventListener('test', null, opts);
  } catch (e) {}

  return supportsPassiveOption;
}


//////////////////
// WEBPACK FOOTER
// ./~/react-scroll-parallax/cjs/utils/testForPassiveScroll.js
// module id = 306
// module chunks = 0